<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" mx-auto>
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0 py-2">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                class="pt-0"
                append-icon="mdi-account-search"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search by Vendor Name, Phone, etc.':'Search'"
                hide-details
                v-model="search"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-download-as
                class="pt-1"
                :headers="vendorSm"
                :items="vendorList"
                title="Vendor List"
                ></v-download-as>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="py-3 px-0">
            <v-layout>
              <v-flex xs12>
                <v-data-table
                :headers="$vuetify.breakpoint.smAndUp?vendorSm:vendor"
                :items="vendorList"
                hide-default-footer
                disable-pagination
                :mobile-breakpoint="0"
                :search="search"
                sort-by="vendor_name"
                class="elevation-3 mt-3">
                <template slot="item" slot-scope="props">
                  <tr @click="prepareEditVendor(props.item)">
                    <td>{{ props.item.vendor_name?props.item.vendor_name:'-' }}</td>
                    <td>{{ props.item.contact_phone?props.item.contact_phone:'-' }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.service_name?props.item.service_name:'-' }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.vendor_status?props.item.vendor_status:'-' }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:20px;')"
      dark fab fixed color="accent" v-if="lAction === 'view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-btn small
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:85px;':'bottom:15px; right:85px;')"
    dark fab fixed v-if="lAction === 'view'"
    color="accent"
    @click.native="prepareUpload">
    <v-icon>mdi-upload</v-icon>
  </v-btn>

  <v-container v-if="lAction === 'create' || lAction === 'update'" class="px-2 pt-0 pb-2" fluid full-height>
    <v-layout row wrap>
      <v-flex xs12 md9 mx-auto>
        <v-form ref="vForm" @submit.prevent="saveVendor(lAction)">
          <v-card flat>
            <v-card-title class="title pb-0 pt-0">
              {{ handy.startWithUpper(lAction) + ' Vendor' }}
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                  v-model="lVendor.vendor_name"
                  label="Vendor Name"
                  :rules="[rules.required]"
                  hide-details
                  maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                  v-model="lVendor.address"
                  label="Address"
                  hide-details
                  maxlength="150"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lVendor.city"
                  label="City"
                  hide-details
                  maxlength="25"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lVendor.pin_code"
                  label="PIN"
                  hide-details
                  maxlength="10"
                  type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lVendor.contact_name"
                  label="Contact Name"
                  hide-details
                  maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lVendor.contact_desig"
                  label="Designation"
                  hide-details
                  maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lVendor.contact_phone"
                  label="Phone"
                  hide-details
                  maxlength="15"
                  type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lVendor.contact_email"
                  label="E-Mail"
                  hide-details
                  maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select
                  v-model="lVendor.vendor_status"
                  label="Status"
                  :items="['Active', 'Inactive', 'Terminated']"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="lVendor.inactive_reason"
                  label="Reason"
                  v-if="lVendor.vendor_status === 'Inactive' || lVendor.vendor_status === 'Terminated'"
                  maxlength="100"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-card>
                    <v-card-title class="pa-2 title primary--text grey lighten-4">
                      <span>Service Capability</span>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="prepareCreateService"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text class="pa-0">
                      <v-data-table
                      :headers="service"
                      :items="serviceList"
                      hide-default-footer
                      disable-pagination
                      :mobile-breakpoint="0">
                      <template slot="item" slot-scope="props">
                        <tr @click="prepareEdit(props.item)">
                          <td>{{ props.item.service_name?props.item.service_name:'-' }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="lAction === 'update'" @click="deleteVendor(lVendor)">delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn @click.stop="cancelChanges">Cancel</v-btn>
            <v-btn type="submit" color="accent" :disabled="beingSaved">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<v-container v-if="lAction === 'upload'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Vendor List
        </v-card-title>
        <div class="mt-3 text-center primary--text title font-italic">In just 4 steps</div>
        <v-card-text class="subtitle-1 black--text">
          <v-layout row wrap>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 1</v-chip>
              <span>Download template</span>
              <span style="float:right;">
                <form method="get" action="/files/Vendor_List_Template.xlsx">
                  <v-btn type="submit" class="mt-0 mb-0" small><v-icon>mdi-download</v-icon></v-btn>
                </form>
              </span>
            </v-flex>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 2</v-chip>
              <span>Fill-in details as guided in template</span>
            </v-flex>
            <v-flex xs12>
              <v-chip small outlined class="info info--text mr-2">Step 3</v-chip>
              <span>Save as CSV <span class="caption">(Comma delimited)</span><br />
              <span class="caption grey--text pl-4 ml-4">
                <span class="ml-4">Go with OK/Yes when prompted while saving</span>
              </span>
            </span>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 4</v-chip>
            <span>Upload the CSV file</span>
            <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>mdi-upload</v-icon></v-btn></span>
            <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validateFile()"/>
          </v-flex>
          <v-flex xs12>
            <div class="mt-3 text-center primary--text title font-italic">Smartility BackBone takes care of rest</div>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 5</v-chip>
            <span>Validate your information</span>
          </v-flex>
          <v-flex xs12>
            <v-chip small outlined class="info info--text mr-2">Step 6</v-chip>
            <span>Create Vendor List</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn @click.native="cancelChanges">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</v-layout>
</v-container>

<!-- validate and upload -->
<v-container v-if="lAction === 'validate'" class="pa-0" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-title class="title pa-0 pl-3">
          Upload Vendor List
        </v-card-title>
        <v-card-text class="text-center pl-2 pr-2">
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 class="info--text mb-2">
                  <span v-if="validateInProgress">Loading and validating the file...</span>
                  <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">mdi-check</v-icon></span>
                  <span v-if="!validFile">File validation is failed <v-icon class="error--text">mdi-close</v-icon></span>
                  <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                  <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                  <span v-if="!totFail && !loadInProgress">Vendor list creation was successfull<v-icon class="success--text">mdi-check</v-icon></span>
                  <span v-if="!totLoaded && totFail && !loadInProgress"><br />Vendor list creation failed<v-icon class="error--text">mdi-close</v-icon></span>
                  <span v-if="totLoaded && totFail && !loadInProgress"><br />Vendor list creation partially failed<v-icon class="warning--text">mdi-close</v-icon></span>
                  <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                </v-flex>
                <v-flex xs4 v-if="totRecs">
                  <v-progress-circular color="info"
                  :value="readyForLoad ? 100 : (recsLoaded.length/totRecs*100)"
                  :size="50" :width="7">
                  {{ readyForLoad ? totValid : recsLoaded.length }}
                </v-progress-circular>
                <br/><div class="caption grey--text">Records</div>
              </v-flex>
              <v-flex xs4 v-if="totRecs">
                <v-progress-circular color="success"
                :value="(totValid/totRecs*100)"
                :size="50" :width="7">
                {{ readyForLoad ? totLoaded : totValid }}
              </v-progress-circular>
              <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
            </v-flex>
            <v-flex xs4 v-if="totRecs">
              <v-progress-circular color="error"
              :value="(totInvalid/totRecs*100)"
              :size="50" :width="7">
              {{ readyForLoad ? totFail : totInvalid }}
            </v-progress-circular>
            <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
          </v-flex>
          <v-flex xs12>
            <v-btn class="mr-4" small @click.native="lAction='upload'">Cancel</v-btn>
            <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadVendor" :disabled="beingSaved">Process the valid records</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 class="mt-2">
        <v-data-table
        :headers="headersm"
        :items="recsLoaded"
        hide-default-footer
        :mobile-breakpoint="0"
        class="elevation-3 text-center"
        >
        <template slot="item" slot-scope="props">
          <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
            <td>{{ props.item.vendor_name }}</td>
            <td>{{ props.item.address }}</td>
            <td>{{ props.item.city }}</td>
            <td>{{ props.item.pin_code }}</td>
            <td>{{ props.item.contact_name }}</td>
            <td>{{ props.item.contact_desig }}</td>
            <td>{{ props.item.contact_phone }}</td>
            <td>{{ props.item.contact_email }}</td>
            <td>{{ props.item.vendor_status }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</v-card-text>
<v-card-actions class="pt-0" v-if="false">
  <v-spacer></v-spacer>
  <v-btn @click.native="cancelChanges">Cancel</v-btn>
</v-card-actions>
</v-card>
</v-flex>
</v-layout>
</v-container>

<v-dialog v-model="showService" persistent max-width="500px">
  <v-form ref="sForm" @submit.prevent="saveService()">
    <v-card flat>
      <v-card-title class="title pb-0">
        Service Capablity
      </v-card-title>
      <v-card-text>
        <v-combobox
        v-model="lService.service_pair"
        label="Service"
        :items="masterServiceList"
        item-text="service_name"
        item-value="service_id"
        :rules="[rules.required]"
        hint="Choose from list or enter new if not found"
        persistent-hint
        ></v-combobox>
      </v-card-text>
      <v-card-actions>
        <v-btn text v-if="lSAction === 'update' && lService.service_pair.service_id === lService.old_service_id" @click="deleteService(lService)">delete</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click.stop="cancelServiceChanges">Cancel</v-btn>
        <v-btn text color="accent" :disabled="beingSaved" type="submit">Save</v-btn>
      </v-card-actions>
    </v-flex>
  </v-card>
</v-form>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<script>
import VDownloadAs from './VDownloadAs.vue'
import handy from '@/utils/handy'
import config from '@/config/app-cfg'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      lAction: '',
      lSAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      search: '',
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      vendorSm: [
        { text: 'Vendor Name', value: 'vendor_name' },
        { text: 'Phone', value: 'contact_phone' },
        { text: 'Service Capablity', value: 'service_name' },
        { text: 'Vendor Status', value: 'vendor_status' }
      ],
      vendor: [
        { text: 'Vendor Name', value: 'vendor_name' },
        { text: 'Phone', value: 'contact_phone' }
      ],
      vendorList: [],
      lVendor: [],
      service: [
        { text: 'Service Name', value: 'service_name' }
      ],
      showService: false,
      lService: {},
      serviceList: [],
      masterServiceList: [],
      hideDelete: false,
      // file upload
      validateInProgress: true,
      readyForLoad: false,
      loadInProgress: true,
      validFile: true,
      headerIssue: false,
      fileError: false,
      totRecs: 0,
      recsLoaded: [],
      totValid: 0,
      totInvalid: 0,
      totLoaded: 0,
      totFail: 0,
      headersm: [
        { text: 'Vendor Name', value: 'vendor_name' },
        { text: 'Address', value: 'address' },
        { text: 'City', value: 'city' },
        { text: 'PIN', value: 'pin_code' },
        { text: 'Contact Name', value: 'contact_name' },
        { text: 'Designation', value: 'contact_desig' },
        { text: 'Phone', value: 'contact_phone' },
        { text: 'Email', value: 'contact_email' },
        { text: 'Status', value: 'vendor_status' }
      ],
      reqHeaders: ['Vendor Name', 'Address', 'City', 'PIN', 'Contact Name', 'Designation', 'Phone', 'Email', 'Status'],
      colNames: [
        {col_name: 'vendor_name', is_required: true},
        {col_name: 'address', is_required: false},
        {col_name: 'city', is_required: false},
        {col_name: 'pin_code', is_required: false},
        {col_name: 'contact_name', is_required: false},
        {col_name: 'contact_desig', is_required: false},
        {col_name: 'contact_phone', is_required: false},
        {col_name: 'contact_email', is_required: false},
        {col_name: 'vendor_status', is_required: false}
      ],
    }
  },
  mounted () {
    this.lAction = 'view'
    this.hideDelete = false
    this.loadVendor()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadVendor () {
      // available Vendor
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getSubVendorByVendorId/', qry)
      .then(response => {
        this.vendorList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    getEmptyVendor () {
      var emptyVendor = {
        vendor_name: '',
        vendor_id: config.VENDOR_ID,
        address: '',
        city: '',
        vendor_status: 'Active',
      }
      return emptyVendor
    },
    prepareCreate () {
      this.lVendor = this.getEmptyVendor()
      this.lService = {}
      this.serviceList = []
      this.lAction = 'create'
      this.loadMasterServiceList()
      this.lSAction = 'view'
    },
    prepareEditVendor (curVendor) {
      this.lVendor = Object.assign({}, curVendor)
      this.lAction = 'update'
      this.lSAction = 'view'
      this.loadMasterServiceList()
      this.loadServices(curVendor)
    },
    loadServices (curVendor) {
      var qry = {
        params: {
          sub_vendor_id: curVendor.sub_vendor_id
        }
      }
      // available Services
      this.axios.get(config.API_URL + '/getServicesBySubVendorId/', qry)
      .then(response => {
        this.serviceList = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadMasterServiceList () {
      // available services for this vendor
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getSubServicesByVendorId/', qry)
      .then(response => {
        this.masterServiceList = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    prepareCreateService () {
      this.lService = {
        sub_vendor_id: this.lVendor.sub_vendor_id,
        service_pair: ''
      }
      this.lSAction = 'create'
      this.showService = true
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    saveService () {
      if (!this.$refs.sForm.validate()) {
        return
      }
      // check if user chosen existing service or add one
      this.beingSaved = true
      if (this.lService.service_pair && this.lService.service_pair.service_id) {
        if (this.lSAction === 'create') {
          this.serviceList.push(this.masterServiceList[this.masterServiceList.findIndex(rec => rec.service_id === this.lService.service_pair.service_id)])
        } else {
          if (this.lService.old_service_id !== this.lService.service_pair.service_id) {
            var cidx = this.serviceList.findIndex(rec => rec.service_id === this.lService.old_service_id)
            this.serviceList.splice(cidx, 1)
            this.serviceList.push(this.masterServiceList[this.masterServiceList.findIndex(rec => rec.service_id === this.lService.service_pair.service_id)])
          }
        }
      } else {
        this.serviceList.push({vendor_id: config.VENDOR_ID, service_name: this.lService.service_pair}) // will newly be created
      }
      this.lVendor.service_name = this.serviceList.map(rec => rec.service_name).join(', ')
      this.showService = false
      this.beingSaved = false
      this.$forceUpdate()
    },
    prepareEdit (curService) {
      this.lService = Object.assign({}, {service_pair: {service_id: curService.service_id, service_name: curService.service_name, sub_vendor_id: curService.sub_vendor_id}})
      this.lService.old_service_id = this.lService.service_pair.service_id
      this.showService = true
      this.lSAction = 'update'
    },
    cancelServiceChanges () {
      this.showService = false
    },
    deleteService (curService) {
      this.beingSaved = true
      var cidx = this.serviceList.findIndex(service => service.service_id === curService.service_pair.service_id)
      if (cidx >= 0) {
        this.serviceList.splice(cidx, 1)
      }
      this.lVendor.service_name = this.serviceList.map(rec => rec.service_name).join(', ')
      this.showService = false
      this.beingSaved = false
      this.$forceUpdate()
    },
    saveVendor (action) {
      // validate and save Changes
      if (this.$refs.vForm.validate()) {
        this.lVendor.serviceList = this.serviceList
        this.beingSaved = true
        this.axios.post(config.API_URL + '/sub-vendor/' + action, this.lVendor)
        .then(response => {
          // refresh the Vendor list
          if (action === 'update') {
            var idx = this.vendorList.findIndex(obj => obj.sub_vendor_id === this.lVendor.sub_vendor_id)
            Object.assign(this.vendorList[idx], this.lVendor)
          } else {
            this.lVendor.sub_vendor_id = response.data
            this.vendorList.push(this.lVendor)
          }
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    deleteVendor (curVendor) {
      if (!confirm('Sure, you want to delete the vendor with vendor name "' + curVendor.vendor_name + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      this.axios.post(config.API_URL + '/sub-vendor/delete', curVendor)
      .then(response => {
        // refresh stats
        var idx = this.vendorList.findIndex(obj => obj.sub_vendor_id === this.lVendor.sub_vendor_id)
        this.vendorList.splice(idx, 1)
        this.beingSaved = false
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    prepareUpload () {
      this.lAction = 'upload'
    },
    promptUpload () {
      this.$refs.ipFile.click()
    },
    validateFile () {
      this.lAction = 'validate'
      this.validateInProgress = true
      this.loadInProgress = true
      this.validFile = true
      this.headerIssue = false
      this.fileError = false
      this.totRecs = 0
      this.recsLoaded = []
      this.totValid = 0
      this.totInvalid = 0
      this.totLoaded = 0
      this.totFail = 0

      // read file
      var file = this.$refs.ipFile.files[0]

      var reader = new FileReader()
      reader.onload = (e) => {
        var content = e.target.result

        // validate & show result
        var allLines = content.split(/\r\n|\n/)
        // ignore empty lines if any
        allLines = allLines.filter(rec => !rec.startsWith(',,,,'))
        this.totRecs = allLines.length - 1
        var headers = allLines[0].split(',')
        // 1. header & required columns
        for (var i = 0; i < this.reqHeaders.length; i++) {
          if (headers[i] !== this.reqHeaders[i]) {
            this.validateInProgress = false
            this.validFile = false
            this.headerIssue = true
            return
          }
        }
        // 2. validate each record
        var res = {}
        var curRec = []
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
            res = {'error': ''}
            for (var c = 0; c < this.colNames.length; c++) {
              if (this.colNames[c].is_required && curRec[c].trim() === '') {
                // special validation
                res['error'] += this.reqHeaders[c] + ' is empty; '
              } else {
                res[this.colNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c]
              }
            }
            this.recsLoaded.push(res)
            if (res['error']) {
              this.totInvalid++
            } else {
              this.totValid++
            }
          }
        }
        if (this.totInvalid) {
          this.validFile = false
        }
        this.validateInProgress = false
      }
      reader.readAsText(file)
    },
    showError (err) {
      this.msg(err, 2)
    },
    async uploadVendor () {
      // create asset List one by one
      this.readyForLoad = true
      this.loadInProgress = true
      this.beingSaved = true
      var curRec = ''
      for (var i = 0; i < this.recsLoaded.length; i++) {
        curRec = this.recsLoaded[i]
        if (!this.recsLoaded[i].error) { // process only valid records
          // fill-in gaps
          this.recsLoaded[i].vendor_id = config.VENDOR_ID
          this.recsLoaded[i].serviceList = []
          // create record
          await this.axios.post(config.API_URL + '/sub-vendor/create', this.recsLoaded[i])
          .then(response => {
            curRec.load_status = 'Loaded'
            this.totLoaded++
          })
          .catch(err => {
            curRec.error = err.response.data
            curRec.load_status = 'Failed'
            this.totFail++
          })
        }
      } // for every record
      if (!this.totFail) {
        this.loadVendor()
        this.lAction = 'view'
      }
      this.loadInProgress = false
      this.beingSaved = false
    }
  }
}
</script>
